import { fetchApi } from '@/config/axiosSetting.ts';
import {
  DownloadFilePrintedPicturesQueryResponseType,
  DownloadFilePrintedPicturesZipType,
} from '@/modules/FileDetail/queries/documentation/downloadZip/downloadFilePrinted/downloadFilePrintedQuery.type';

export const downloadFilePrintedQueryFunction = ({
  id,
  images_quality,
  show_image,
}: DownloadFilePrintedPicturesZipType): Promise<DownloadFilePrintedPicturesQueryResponseType> =>
  fetchApi.get(`documents/${id}/file_printed_version_response/download/`, {
    params: { images_quality, show_image },
  });
